import { gql } from '@apollo/client';

export default gql`
  query GetAcademyCourseCurrentPeriodDetails($courseId: String!) {
    currentPeriod(courseId: $courseId)
      @rest(
        type: "BilledCourseCurrentPeriod"
        path: "academy/courses/{args.courseId}/current-period-details"
      ) {
      name
      owner {
        _id
        name
        email
      }
      startDate
      totalDebt
      students {
        name
        email
        personalId
        startDate
        endDate
        duration
      }
    }
  }
`;
